export default {
  managementEvents:'/general/inflation/toss/', //打点,
  order:{
    dataDetails:'/general/life/rescue', //订单详情
    AutoApply:'/general/life/damn', //是否展示自动复借按钮
    SettledAutoApply:'/general/life/sustainable', //是否自动复借
    RepaymentDetail:'/general/life/facility', //还款详情
    UpOrderUtr:'/api/order/up-order-utr', //更新订单utr
    DelayFlexble:'/general/soccer/happiness', //展期订单详情
    BankCard:'/general/welcome/rack' //获取银行卡列表
  },
  customer:{
    CustomerPhone:'/general/inflation/businessman',//获取客服电话
    submitComplaint: '/general/narrative/retire' // 提交用户反馈
  }
}